import { render } from "./CapturaFoto.vue?vue&type=template&id=f0f1217e&scoped=true"
import script from "./CapturaFoto.vue?vue&type=script&lang=js"
export * from "./CapturaFoto.vue?vue&type=script&lang=js"

import "./CapturaFoto.vue?vue&type=style&index=0&id=f0f1217e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f1217e"]])

export default __exports__